import React, { useState } from "react";
import { Grid, TextField, Button, Box } from "@mui/material";
import Angled from "../assets/Images/Angled.png";
import "../styles/Section1.css";
import { sendEmail } from "../services/Request";

const SignupCard = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      alert("Please enter a valid email.");
      return;
    }

    sendEmail("/mail.php", { email });
    alert("Subscription successful! Check your email.");
  };

  return (
    <Grid
      container
      sx={{
        mt: 5,
        mb: 3,
        backgroundColor: "#F9FAFB",
        paddingBottom: "60px",
        paddingTop: "30px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        item
        sm={10}
        sx={{
          backgroundColor: "#530B79",
          position: "relative",
          backgroundImage: `url(${Angled})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
          backgroundSize: "cover",
          borderRadius: "16px",
          paddingTop: "60px",
          paddingBottom: "60px",
        }}
      >
        <div className="s-heading">Ready to Start Saving?</div>
        <div className="s-text">
          Join the community of savers who are reaching their financial goals
          with D'Ajoo.
        </div>
        <div className="s-box">
          <Box display="flex" mt={1}>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ bgcolor: "#FFFFFF", flexGrow: 1, borderRadius: 1 }}
            />
            <Button
              variant="contained"
              sx={{ ml: 1, bgcolor: "#6B21A8" }}
              onClick={handleSubscribe}
            >
              Subscribe
            </Button>
          </Box>
        </div>
      </Grid>
    </Grid>
  );
};

export default SignupCard;
